// Generated by CoffeeScript 1.6.3
(function() {
  rjm.ui.ChartBuilderViewState = Backbone.Model.extend({
    initialize: function(options) {
      if (!options.hasOwnProperty("chartValidationErrors") || !options.hasOwnProperty("trendsOnly") || !options.hasOwnProperty("isCreate") || !options.hasOwnProperty("isSaving") || !options.hasOwnProperty("filtersApplied")) {
        throw "InvalidConstructorArgs - viewState";
      }
    }
  });

}).call(this);
